export default class ThoughtsTopics {
  constructor(el) {
    this.el = el
    this.setVars()
    this.bindEvents()
  }

  setVars() {
    this.dropdown = this.el.querySelector('select')
    //this.resetBtn = this.el.querySelector('button')
  }

  bindEvents() {
    this.dropdown.addEventListener('change', this.handleChange)
    //this.resetBtn.addEventListener('click', this.handleReset)
  }

  handleChange = () => {
      window.location = this.dropdown.value;
      //this.el.submit()
  }

  handleReset = () => {
    this.dropdown.selectedIndex = 0
    //this.handleChange()
  }
}
